import React from 'react'
import Select from 'react-select'
import novoice from '../../../assets/images/icons/novoice.svg'
import intermediate from '../../../assets/images/icons/intermediate.svg'
import proficient from '../../../assets/images/icons/proficient.svg'
import master from '../../../assets/images/icons/master.svg'
import elite from '../../../assets/images/icons/elite.svg'
import { MdKeyboardArrowRight } from "react-icons/md";

const Statistics = () => {

    const options = [
        { value: 'chocolate', label: 'Traits 1' },
        { value: 'strawberry', label: 'Traits 2' },
        { value: 'vanilla', label: 'Traits 3' }
    ]


    return (
        <>
            <div className="card categorylevel">
                <div className="card-body">
                    <div className='d-flex align-items-center justify-content-between'>
                        <h6>Category level</h6>
                        <Select options={options} />
                    </div>
                    <ul className='pt-3'>
                        <li>
                            <div className='d-flex gap-2'>
                                <span><img src={novoice} alt="" /> </span>
                                <div className=''>
                                    <h6 className='mb-0 font-xs'>20</h6>
                                    <p className='mb-0 font-xss color-light'>Novoice</p>
                                </div>
                            </div>
                            <MdKeyboardArrowRight />
                        </li>
                        <li>
                            <div className='d-flex gap-2'>
                                <span><img src={intermediate} alt="" /> </span>
                                <div className=''>
                                    <h6 className='mb-0 font-xs'>20</h6>
                                    <p className='mb-0 font-xss color-light'>Intermediate</p>
                                </div>
                            </div>
                            <MdKeyboardArrowRight />
                        </li>
                        <li>
                            <div className='d-flex gap-2'>
                                <span><img src={proficient} alt="" /> </span>
                                <div className=''>
                                    <h6 className='mb-0 font-xs'>20</h6>
                                    <p className='mb-0 font-xss color-light'>Proficient</p>
                                </div>
                            </div>
                            <MdKeyboardArrowRight />
                        </li>
                        <li>
                            <div className='d-flex gap-2'>
                                <span><img src={master} alt="" /> </span>
                                <div className=''>
                                    <h6 className='mb-0 font-xs'>20</h6>
                                    <p className='mb-0 font-xss color-light'>master</p>
                                </div>
                            </div>
                            <MdKeyboardArrowRight />
                        </li>
                        <li>
                            <div className='d-flex gap-2'>
                                <span><img src={elite} alt="" /> </span>
                                <div className=''>
                                    <h6 className='mb-0 font-xs'>20</h6>
                                    <p className='mb-0 font-xss color-light'>Elite</p>
                                </div>
                            </div>
                            <MdKeyboardArrowRight />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default Statistics
